function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { z } from 'zod';
import { useApplicationPageAggregatedData, useApplicationPageMutation } from "./aggregatedData";
var UpdateApplicationRequest = z.object({
  programs: z.array(z.object({
    legacyIntakeId: z.string(),
    legacyProgramId: z.string(),
    programType: z["enum"](['main', 'esl']),
    actualStartDate: z.string(),
    alternateActualStartDate: z.string().optional()
  })).optional(),
  processingInformation: z.object({
    stageId: z.literal('submission')
  }).optional(),
  backupPrograms: z.number().array().optional()
});
/**
 * Data mutation hook for updating application on the Application Detail page
 * Returns aggregated data for Application Detail page. If not on the Application Detail page, use 'useUpdateApplicationOutsidePage'
 * @see: https://applyboard.atlassian.net/wiki/spaces/APP/pages/2862612698/Aggregated+Page-Level+Data-fetching
 */
export function useUpdateApplication() {
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useApplicationPageMu = useApplicationPageMutation(function (update) {
      return {
        url: "/awa/v1/applications/".concat(application.id),
        method: 'PATCH',
        body: {
          data: {
            id: application.id,
            type: 'application',
            attributes: update
          }
        }
      };
    }),
    mutate = _useApplicationPageMu.mutate,
    isLoading = _useApplicationPageMu.isLoading;
  return {
    updateApplication: mutate,
    isUpdatingApplication: isLoading
  };
}
export var ProgramType = /*#__PURE__*/function (ProgramType) {
  ProgramType["Main"] = "main";
  ProgramType["Esl"] = "esl";
  return ProgramType;
}({});
export function useApplication() {
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(aggregatedData) {
        var data = aggregatedData.included.find(function (item) {
          return item.type === 'application';
        });
        if (!data) {
          throw new Error('Application not found in aggregated data.');
        }
        return _objectSpread(_objectSpread({}, data.attributes), {}, {
          id: data.id
        });
      }
    }),
    data = _useApplicationPageAg.data;
  if (!data) {
    throw new Error('Application not found in aggregated data.');
  }
  return {
    application: data
  };
}
export function useLegacyApplication() {
  var _useApplicationPageAg2 = useApplicationPageAggregatedData({
      select: function select(aggregatedData) {
        var data = aggregatedData.included.find(function (item) {
          return item.type === 'legacy_application';
        });
        if (!data) {
          throw new Error('Legacy application not found in aggregated data.');
        }
        return _objectSpread(_objectSpread({}, data.attributes), {}, {
          id: data.id
        });
      }
    }),
    data = _useApplicationPageAg2.data;
  if (!data) {
    throw new Error('Legacy application not found in aggregated data.');
  }
  return {
    legacyApplication: data
  };
}
export function useCancelApplication() {
  var _useApplicationPageMu2 = useApplicationPageMutation(function (_ref) {
      var cancelReasonId = _ref.cancelReasonId,
        cancelReasonLabel = _ref.cancelReasonLabel,
        cancelNote = _ref.cancelNote;
      var queryParams = ["update_type=cancel", "cancellation_reason_id=".concat(cancelReasonId), "cancellation_reason=".concat(cancelReasonLabel), cancelNote ? "cancellation_additional_note=".concat(encodeURIComponent(cancelNote)) : ''];
      return {
        url: "/application/status?".concat(queryParams.join('&')),
        method: 'PATCH',
        body: {
          flag: true
        }
      };
    }),
    mutate = _useApplicationPageMu2.mutate,
    isLoading = _useApplicationPageMu2.isLoading;
  return {
    cancelApplication: mutate,
    isCancellingApplication: isLoading
  };
}